import { CartItem } from 'shared/types/cart';

export function getYouPayAmount(item: CartItem): number {
  const { totalPrice = 0 } = item.cartItemPriceDTO || {};
  return item.youPayPrice > 0 ? item.youPayPrice : totalPrice;
}

export function getSavedAmount(item: CartItem): number | null {
  const { totalMRP = 0 } = item.cartItemPriceDTO || {};
  const youPayAmount = getYouPayAmount(item);
  const savedAmount = totalMRP - youPayAmount;

  return savedAmount > 0 ? savedAmount : null;
}

export function getLowStockMessage(item: CartItem): string | null {
  if (item.stockMsg) {
    return item.stockMsg;
  }

  if (item.availableQty > 0 && item.availableQty <= 5) {
    return `Only ${item.availableQty} left`;
  }

  return null;
}

interface CardControlVisibilityParams {
  isEligibleCartPartialCheckoutEnabled: boolean;
  isProductSelectedtoCheckout: boolean;
  availableQty: number;
  maxSaleableQty: number;
  isSizeSelectorOnCart: boolean;
  sizeSelectorVariant: string;
  sizeSelectorVariantA: string;
}

export function getCanShowQtyChange({
  isEligibleCartPartialCheckoutEnabled,
  isProductSelectedtoCheckout,
  availableQty,
  maxSaleableQty,
}: CardControlVisibilityParams): boolean {
  const maxSelectableQty = Math.min(availableQty, maxSaleableQty);

  if (isEligibleCartPartialCheckoutEnabled) {
    return isProductSelectedtoCheckout && maxSelectableQty > 1;
  }

  return maxSelectableQty > 1;
}

export function getCanShowSizeChange({
  isEligibleCartPartialCheckoutEnabled,
  isProductSelectedtoCheckout,
  isSizeSelectorOnCart,
  sizeSelectorVariant,
  sizeSelectorVariantA,
}: CardControlVisibilityParams): boolean {
  if (isEligibleCartPartialCheckoutEnabled) {
    return (
      isProductSelectedtoCheckout &&
      isSizeSelectorOnCart &&
      sizeSelectorVariant === sizeSelectorVariantA
    );
  }

  return isSizeSelectorOnCart && sizeSelectorVariant === sizeSelectorVariantA;
}

export function getCanShowSelectedItemAttributes(
  isEligibleCartPartialCheckoutEnabled: boolean,
  isProductSelectedtoCheckout: boolean
): boolean {
  if (isEligibleCartPartialCheckoutEnabled) {
    return isProductSelectedtoCheckout;
  }

  return true;
}
